import type { ReactNode } from "react";
import type { UseFormGetValues, UseFormSetValue } from "react-hook-form";
import type { ICampaignWizardForm } from "../../../../../../../../../shared/types/form.type";

export type ConversionListItem = { key: string; node: ReactNode };

const SELECTIVE_OPTIMIZATION_FIELD =
	"campaign_context.campaign.selective_optimization_conversion_actions" as const;

/** Формирует обработчики выбора / удаления конверсий для поля selective_optimization_conversion_actions. */
export function createConversionHandlers(params: {
	allKey: string;
	conversionsSelectItems: ConversionListItem[];
	getValues: UseFormGetValues<ICampaignWizardForm>;
	setValue: UseFormSetValue<ICampaignWizardForm>;
}) {
	const { allKey, conversionsSelectItems, getValues, setValue } = params;

	// Добавляет конверсию по key в selective_optimization_conversion_actions (заглушку «оберіть…» не додаємо).
	const onConversionSelect = (key: string) => {
		if (key === allKey) return;
		const item = conversionsSelectItems.find((i) => i.key === key);
		if (!item) return;
		const prev = getValues(SELECTIVE_OPTIMIZATION_FIELD) ?? [];
		setValue(SELECTIVE_OPTIMIZATION_FIELD, [...prev, item.key], {
			shouldDirty: true,
		});
	};

	// Удаляет конверсию из selective_optimization_conversion_actions.
	const onConversionRemove = (key: string) => {
		const prev = getValues(SELECTIVE_OPTIMIZATION_FIELD) ?? [];
		setValue(
			SELECTIVE_OPTIMIZATION_FIELD,
			prev.filter((k: string) => k !== key),
			{ shouldDirty: true },
		);
	};

	return { onConversionSelect, onConversionRemove };
}
